"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = featuredPresenter;
var _types = require("../../actions/program/types");
function featuredPresenter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_FEATURED_PRESENTER) {
    return action.payload.presenterId;
  }
  return state;
}